// These are installed on window. so they are accessible from the native apps

import { blobUrlToDataUrl } from "./utils";

export function installNativeUtilities() {
	window.nativeHelperBlobUrlToDataUrl = (blobUrl, callback) => {
		blobUrlToDataUrl(blobUrl).then(dataUrl => callback(dataUrl));
	};
}
